import React from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/auth/useAuth";

export function DashboardPage(): React.ReactElement {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Добро пожаловать, {user?.username}</h1>
        <p className="text-muted-foreground">Buh Helper — этап 1: auth + админка</p>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Счета-фактуры</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            Загрузка и создание документов поступления — появится на этапе 5.
          </CardContent>
        </Card>
        {user?.is_admin && (
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Пользователи</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Создание и настройка доступа сотрудников.
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
